import axios from 'axios';
import Swal from 'sweetalert2';
import { store } from '../App';
import { LOGIN_DOMAIN } from './Configuration';

const axiosTokenService = axios.create();
axiosTokenService.interceptors.response.use(async (config) => { //changes by amman
    return config;
}, function (error) {
    store.dispatch({ type: "HIDE_SPINNER" });
    if (error?.response?.status === 401) {
        Swal.fire({
            icon: 'error',
            title: 'Session Expired',
            confirmButtonText: 'OK'
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.clear()
              window.location.href=LOGIN_DOMAIN+"/Logout.do"
            }
        })
    }
    else if (error?.response?.status === 400) {
        // Handle status code 400
        Swal.fire({
            icon: 'error',
            title: 'Session Expired',
            confirmButtonText: 'OK'
        }).then((result) => {
            if (result.isConfirmed) {
              window.location.href=LOGIN_DOMAIN+"/Logout.do"
            }
        })
      }
    
    else if (error?.response?.status === 500) {
    }
    return Promise.reject(error);
});

axiosTokenService.interceptors.request.use(async (config) => { //changes by amman
    const token = "Bearer" + ' ' + localStorage?.getItem("token").replace(/['"]+/g, '');  
    config.headers.Authorization = token;
    return config;
}, function (error) {
    store.dispatch({ type: "HIDE_SPINNER" });
    if (error?.response?.status === 401) {
        Swal.fire({
            icon: 'error',
            title: 'Session Expired',
            confirmButtonText: 'OK'
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href=LOGIN_DOMAIN+"/Logout.do"
            }
        })
    }else if (error?.response?.status === 500) {
     }
    return Promise.reject(error);
});

export default axiosTokenService;
